import React, { useRef, useState } from "react";
import Bgimg from "../Assets/IN-en-20240226-popsignuptwoweeks-perspective_alpha_website_small.jpg";
import Header from "./Header";
import { checkValidData } from "../utils/Validation";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
} from "firebase/auth";
import { auth } from "../utils/Firebase";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addUser } from "../utils/UserSclice";
import { UserImg } from  "../utils/Constants";

function Login() {
  const [isSignInForm, setIsSigninForm] = useState(true);
  const [errorMessage, seterrorMessage] = useState(null);
  const navigate = useNavigate();

  const email = useRef(null);
  const password = useRef(null);
  const Name = useRef("");
  const dispatch = useDispatch();
  const handleButtonClick = () => {
    // console.log(email.current.value);
    // console.log(password.current.value);
    const message = checkValidData(
      email.current.value,
      password.current.value,
      Name.current.value
    );
    seterrorMessage(message);
    if (message) return;

    if (!isSignInForm) {
      //Sign UP LOGIC
      createUserWithEmailAndPassword(
        auth,
        email.current.value,
        password.current.value
      )
        .then((userCredential) => {
          // Signed in
          const user = userCredential.user;
          updateProfile(user, {
            displayName: Name.current.value,
            photoURL: UserImg,
          })
            .then(() => {
              // Profile updated!
              const { uid, email, displayName, photoURL } = auth.currentUser;
              dispatch(
                addUser({
                  uid: uid,
                  email: email,
                  displayName: displayName,
                  photoURL: photoURL,
                })
              );
              // console.log(user);

              // ...
            })
            .catch((error) => {
              seterrorMessage(error.message);
            });

          // ...
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          seterrorMessage(errorCode + "-" + errorMessage);
        });
    } else {
      // Sign IN logic
      signInWithEmailAndPassword(
        auth,
        email.current.value,
        password.current.value
      )
        .then((userCredential) => {
          // Signed in
          const user = userCredential.user;
          // console.log(user);
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          seterrorMessage(errorCode + "-" + errorMessage);
        });
    }
  };

  const toggleSignForm = () => {
    setIsSigninForm(!isSignInForm);
  };

  return (
    <div className="">
      <Header />
      <div className="absolute">
        <img className="object-cover h-screen md:w-screen " src={Bgimg} alt="Bg-img" />
      </div>

      <from
        onSubmit={(e) => e.preventDefault()}
        className="w-full  sm:w-full    md:w-[400px] absolute p-12 bg-black bg-opacity-80 my-36 mx-auto right-0 left-0 text-white"
      >
        <h1 className="font-bold text-xl md:text-3xl py-4">
          {isSignInForm ? "Sign-In" : "Sign-Up"}
        </h1>

        {!isSignInForm && (
          <input
            type="text"
            ref={Name}
            placeholder="Enter Your Name"
            className="p-4 my-2 w-full bg-gray-800 bg-opacity-80 rounded-lg"
          />
        )}

        <input
          ref={email}
          type="text"
          placeholder="email Address"
          className="p-4 my-2 w-full bg-gray-800 bg-opacity-80 rounded-lg"
        />

        <input
          ref={password}
          type="password"
          placeholder="Password"
          className="p-4 my-2 w-full bg-gray-800 bg-opacity-80 rounded-lg"
        />

        <p className="py-3 text-red-800">{errorMessage}</p>

        <button
          onClick={handleButtonClick}
          className="p-4 my-4 bg-red-600 w-full rounded-lg"
        >
          {isSignInForm ? "Sign-In" : "Sign-Up"}
        </button>

        <p className="cursor-pointer my-7" onClick={toggleSignForm}>
          {isSignInForm
            ? "New to Netflix? Sign Up Now"
            : "Already registered? Sign Up Now.."}
        </p>
      </from>
    </div>
  );
}

export default Login;
